exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".row {\n  margin-bottom: 20px;\n  padding: 20px; }\n\nbody {\n  background: #fafafa; }\n\n.model-form {\n  padding: 15px; }\n\n.card {\n  margin-left: 20px;\n  margin-right: 20px; }\n\n.child-child-child-cmp {\n  border: 1px solid grey;\n  border-radius: 3px;\n  padding: 15px; }\n\n.alert {\n  display: block; }\n\n.btn {\n  margin-top: 15px;\n  display: block;\n  margin-bottom: 10px; }\n\n.position {\n  margin-top: 2px;\n  border: 1px solid grey;\n  padding: 10px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.scss
// module id = 180
// module chunks = 1